import * as React from 'react';

const DEFAULT_ALGOLIA_CONFIG = {
    isEnabled: false,
    algoliaInstantSearchProps: {
        indexName: '',
        searchState: {},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onSearchStateChange: ()=>{},
        searchClient: {}
    },
    facets: [],
    pageSize: 24,
    sortIndices: [],
    presetQueryObject: {},
    ruleContexts: [],
    indices: []
};
const AlgoliaConfig = /*#__PURE__*/ React.createContext(DEFAULT_ALGOLIA_CONFIG);
const useAlgoliaConfig = ()=>React.useContext(AlgoliaConfig)
;

export { AlgoliaConfig, useAlgoliaConfig };
//# sourceMappingURL=AlgoliaConfig.js.map
